import type { SidePanelSession } from '../../types';
import { resolveCommandHandler } from '../domainLogic/resolveCommandHandler';

type NotificationHandler = (input: unknown, context: unknown) => unknown | Promise<unknown>;

export function dispatchOwnerNotification(
    session: SidePanelSession,
    commandName: string,
    input: unknown,
    handlersByOwner: ReadonlyMap<string, ReadonlyMap<string, NotificationHandler>>
) {
    const resolved = resolveCommandHandler(session.ownerChain, commandName, handlersByOwner);
    if (!resolved) return;

    try {
        Promise.resolve(
            resolved.handler(input, {
                subject: session.subject,
                sessionId: session.sessionId,
                panelId: session.panelId
            })
        ).catch((error) => console.error(`Side-panel notification handler "${commandName}" failed`, error));
    } catch (error) {
        console.error(`Side-panel notification handler "${commandName}" failed`, error);
    }
}
